(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vb-core"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.velmoraBotanica) return;
  const state = {quantity: 1, cart: null, busy: false};
  window.velmoraBotanica = state;
  const all = (selector, root = document) => [...root.querySelectorAll(selector)];
  const contactTopic = document.querySelector('[data-vb-contact-topic]');
  const requestedTopic = new URLSearchParams(window.location.search).get('topic');
  if (contactTopic && ['question','tracking','return','privacy'].includes(requestedTopic)) contactTopic.value = requestedTopic;
  const root = () => window.Shopify?.routes?.root || '/';
  const config = () => document.querySelector('[data-vb-config]');
  const words = () => JSON.parse(config()?.textContent || '{}');
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency',currency}).format(cents / 100);
  const synchronize = () => {
    all('[data-vb-quantity]').forEach(input => {input.checked = Number(input.value) === state.quantity;});
    all('[data-vb-form]:not([data-bundle-mode="true"]) input[name="quantity"]').forEach(input => {input.value = state.quantity;});
    all('[data-vb-total]').forEach(el => {el.textContent = state.quantity === 3 ? el.dataset.priceThree : el.dataset.priceOne;});
    all('[data-vb-selected]').forEach(el => {el.textContent = state.quantity === 3 ? words().three : words().one;});
  };
  const moonOptions = () => all('moonbundle-component .moonbundle-option', document.querySelector('[data-vb-primary-buy]') || document);
  const syncMoonOfferCards = () => {
    const options = moonOptions();
    // These shortcuts correspond to the two configured Moon tiers: one and three bottles.
    all('[data-vb-choice]').forEach(card => {
      const option = options[card.dataset.vbChoice === '3' ? 1 : 0];
      const price = option?.querySelector('.moonbundle-option-single-price')?.textContent.trim() || '';
      const saving = card.dataset.vbChoice === '3' ? option?.querySelector('.moonbundle-label-inside')?.textContent.trim() || '' : '';
      [['[data-vb-moon-price]', price], ['[data-vb-moon-saving]', saving]].forEach(([selector, text]) => {
        const node = card.querySelector(selector);
        if (node.textContent !== text) node.textContent = text;
        if (node.hidden !== !text) node.hidden = !text;
      });
      const selected = !!option?.classList.contains('moonbundle-option-active');
      if (card.classList.contains('is-selected') !== selected) card.classList.toggle('is-selected', selected);
    });
  };
  const storyOffset = (track, index) => {
    const cards = all('.vb-story-card', track);
    return cards[index] ? cards[index].offsetLeft - cards[0].offsetLeft : 0;
  };
  const updateStoryDots = track => {
    const cards = all('.vb-story-card', track);
    const end = track.scrollWidth - track.clientWidth;
    let index = 0;
    cards.forEach((card, i) => {if (Math.abs(storyOffset(track,i)-track.scrollLeft) < Math.abs(storyOffset(track,index)-track.scrollLeft)) index=i;});
    if (end > 2 && track.scrollLeft >= end - 2) index = cards.length - 1;
    all('[data-vb-story-index]',track.parentElement).forEach((dot,i)=>dot.setAttribute('aria-pressed',i===index));
  };
  const showGallery = (gallery, index) => {
    const slides = all('[data-vb-slide]', gallery);
    if (!slides.length) return;
    const active = (index + slides.length) % slides.length;
    gallery.dataset.index = active;
    slides.forEach((slide,i) => {slide.hidden = i !== active;});
    all('[data-vb-gallery-index]', gallery).forEach(button => button.setAttribute('aria-pressed', Number(button.dataset.vbGalleryIndex) === active));
    const warmNeighbours = () => {
      [1, -1].forEach(offset => {
        const image = slides[(active + offset + slides.length) % slides.length].querySelector('img');
        if (image) image.loading = 'eager';
      });
    };
    const activeImage = slides[active].querySelector('img');
    if (activeImage && !activeImage.complete) {
      activeImage.loading = 'eager';
      activeImage.addEventListener('load', warmNeighbours, {once:true});
    } else warmNeighbours();
  };
  const closeDialog = dialog => {if(dialog?.open) dialog.close();};
  const openDialog = (id, button) => {
    const dialog = document.getElementById(id);
    if(!dialog) return;
    state.opener = button;
    dialog.showModal();
  };
  const openCommerceCart = trigger => {
    const moon = document.querySelector('moonbundle-cart-drawer-block');
    if (moon && typeof moon.open === 'function') {
      document.dispatchEvent(new CustomEvent('drawerOpen'));
    } else {
      openDialog('vb-cart', trigger);
      fetchCart();
    }
  };
  const cartStatus = text => {all('[data-vb-cart-status]').forEach(el => {el.textContent = text;});};
  const renderCart = cart => {
    state.cart = cart;
    all('[data-vb-count]').forEach(el => {el.textContent = cart.item_count || '';});
    const target = document.querySelector('[data-vb-cart-items]');
    if (!target) return;
    target.replaceChildren();
    const dictionary = words();
    if (!cart.item_count) {const p = document.createElement('p');p.textContent = dictionary.empty;target.append(p);}
    cart.items.forEach(item => {
      const element = document.createElement('article');element.className = 'vb-cart-item';
      const name = document.createElement('strong');name.textContent = item.product_title;
      const price = document.createElement('span');price.textContent = money(item.final_line_price, cart.currency);
      const row = document.createElement('div');row.className='vb-cart-item__bottom';
      const label = document.createElement('label');label.textContent = dictionary.quantity + ' ';
      const input = document.createElement('input');input.type='number';input.min='0';input.step='1';input.value=item.quantity;input.dataset.vbCartKey=item.key;input.setAttribute('aria-label',dictionary.quantity + ': ' + item.product_title);label.append(input);
      const remove = document.createElement('button');remove.type='button';remove.className='vb-cart-remove';remove.dataset.vbRemove=item.key;remove.textContent=dictionary.remove;
      row.append(label,remove);element.append(name,price,row);target.append(element);
    });
    all('[data-vb-cart-total]').forEach(el => {el.textContent=money(cart.total_price,cart.currency);});
    all('[data-vb-checkout]').forEach(el => {el.disabled=!cart.item_count || dictionary.preview;});
  };
  const fetchCart = async () => {
    try {const response=await fetch(root()+'cart.js');if(!response.ok) throw new Error();renderCart(await response.json());cartStatus('');}
    catch {cartStatus(words().error);}
  };
  const changeCart = async (key, quantity) => {
    if(state.busy || !Number.isInteger(quantity) || quantity < 0) return;
    state.busy=true;
    try {const response=await fetch(root()+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})});if(!response.ok)throw new Error();renderCart(await response.json());cartStatus('');}
    catch {cartStatus(words().error);await fetchCart();cartStatus(words().error);}
    finally {state.busy=false;}
  };
  const initFormula = formula => {
    const mobile = matchMedia('(max-width:749px)').matches;
    const tabs = formula.querySelector('[data-vb-tabs]');
    const panels = all('[data-vb-panel]',formula);
    const index = Number(formula.dataset.active || 0);
    tabs.hidden = mobile;
    formula.dataset.enhanced = !mobile;
    panels.forEach((panel,i)=>{panel.hidden = !mobile && i!==index;panel.open = mobile ? i===0 : true;if(mobile){panel.removeAttribute('role');panel.removeAttribute('aria-labelledby');}else{panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',all('[data-vb-tab]',formula)[i].id);}});
    all('[data-vb-tab]',formula).forEach((tab,i)=>{tab.setAttribute('aria-selected',i===index);tab.tabIndex=i===index?0:-1;});
  };
  const init = () => {
    synchronize();
    all('[data-vb-gallery]').forEach(gallery=>{
      showGallery(gallery,Number(gallery.dataset.index||0));
      if(gallery.dataset.bound)return;gallery.dataset.bound='true';
      let start;
      gallery.addEventListener('touchstart',event=>{start={x:event.touches[0].clientX,y:event.touches[0].clientY};},{passive:true});
      gallery.addEventListener('touchend',event=>{if(!start)return;const dx=event.changedTouches[0].clientX-start.x;const dy=event.changedTouches[0].clientY-start.y;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5)showGallery(gallery,Number(gallery.dataset.index||0)+(dx<0?1:-1));start=null;},{passive:true});
    });
    all('[data-vb-formula]').forEach(initFormula);
    all('[data-vb-stories]').forEach(track=>{
      if(track.dataset.bound)return;track.dataset.bound='true';
      track.addEventListener('scroll',()=>updateStoryDots(track),{passive:true});
      track.addEventListener('keydown',event=>{
        if(event.target!==track||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        event.preventDefault();
        const step=storyOffset(track,1)||track.clientWidth;
        const left=event.key==='Home'?0:event.key==='End'?track.scrollWidth:track.scrollLeft+(event.key==='ArrowRight'?step:-step);
        track.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
      });
      updateStoryDots(track);
    });
    state.observer?.disconnect();
    const hero = document.querySelector('[data-vb-primary-buy]');
    const sticky = document.querySelector('[data-vb-sticky]');
    if(hero&&sticky){state.observer=new IntersectionObserver(([entry])=>{sticky.classList.toggle('is-visible',!entry.isIntersecting&&entry.boundingClientRect.bottom<0);},{threshold:0});state.observer.observe(hero);}
    all('dialog.vb-dialog').forEach(dialog=>{
      if(dialog.dataset.bound)return;dialog.dataset.bound='true';
      dialog.addEventListener('close',()=>{state.opener?.focus({preventScroll:true});});
      dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)closeDialog(dialog);});
    });
  };
  document.addEventListener('change',event=>{

    if(event.target.matches('[data-vb-quantity]')) {state.quantity=Number(event.target.value);synchronize();}
    if(event.target.matches('[data-vb-cart-key]')) changeCart(event.target.dataset.vbCartKey,Number(event.target.value));
  });
  document.addEventListener('click',event=>{
    const button=event.target.closest('button,a');if(!button)return;
    if (button.hasAttribute('data-vb-choice')) {
      const target = document.getElementById('vb-offer-picker');
      if (target) {
        event.preventDefault();
        const index = button.dataset.vbChoice === '3' ? 1 : 0;
        const option = moonOptions()[index];
        if (option) option.click();
        else if (!target.querySelector('[data-bundle-mode="true"]')) {state.quantity=Number(button.dataset.vbChoice);synchronize();}
        target.setAttribute('tabindex','-1');
        (option || target).focus({preventScroll:true});
        target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
        syncMoonOfferCards();
      }
    }
    if(button.hasAttribute('data-vb-privacy')&&window.privacyBanner?.showPreferences){event.preventDefault();window.privacyBanner.showPreferences({locale:button.dataset.locale,country:button.dataset.country}).catch(()=>{location.href=button.href;});}
    if(button.dataset.vbOpen){event.preventDefault();if(button.dataset.vbOpen==='vb-cart')openCommerceCart(button);else openDialog(button.dataset.vbOpen,button);}
    if(button.hasAttribute('data-vb-close'))closeDialog(button.closest('dialog'));
    if(button.closest('#vb-menu')&&button.matches('a')) {
      const dialog=button.closest('dialog');
      const destination=new URL(button.href,location.href);
      const samePage=destination.origin===location.origin&&destination.pathname.replace(/\/$/,'')===location.pathname.replace(/\/$/,'');
      const target=samePage&&destination.hash?document.getElementById(destination.hash.slice(1)):null;
      if(target) {
        event.preventDefault();
        dialog.addEventListener('close',()=>{
          history.pushState(null,'',destination.pathname+destination.search+destination.hash);
          target.setAttribute('tabindex','-1');
          target.focus({preventScroll:true});
          target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
        },{once:true});
      }
      closeDialog(dialog);
    }
    if(button.hasAttribute('data-vb-gallery-index'))showGallery(button.closest('[data-vb-gallery]'),Number(button.dataset.vbGalleryIndex));
    if(button.hasAttribute('data-vb-gallery-step')){const gallery=button.closest('[data-vb-gallery]');showGallery(gallery,Number(gallery.dataset.index||0)+Number(button.dataset.vbGalleryStep));}
    if(button.hasAttribute('data-vb-story-index')){const track=button.closest('[data-vb-story-section]').querySelector('[data-vb-stories]');track.scrollTo({left:storyOffset(track,Number(button.dataset.vbStoryIndex)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});}
    if(button.hasAttribute('data-vb-tab')){const formula=button.closest('[data-vb-formula]');formula.dataset.active=button.dataset.vbTab;initFormula(formula);}
    if(button.dataset.vbRemove)changeCart(button.dataset.vbRemove,0);
    if(button.hasAttribute('data-vb-sticky-buy')){if(button.dataset.bundleMode==='true')document.getElementById('vb-offer-picker')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});else document.querySelector('[data-vb-primary-buy] form')?.requestSubmit();}
  });
  document.addEventListener('keydown',event=>{
    if(!event.target.matches('[data-vb-tab]')||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
    event.preventDefault();const tabs=all('[data-vb-tab]',event.target.parentElement);let index=tabs.indexOf(event.target);index=event.key==='Home'?0:event.key==='End'?tabs.length-1:(index+(event.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;tabs[index].click();tabs[index].focus();
  });
  // Keep the preview gate ahead of app-level product submit handlers.
  document.addEventListener('submit', event => {
    if (event.target.matches('[data-vb-form][data-enabled="false"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  // Handle the custom form before Moon's document-level submit redirect.
  // Moon's fetch interceptor still supplies the selected offer and discount.
  document.addEventListener('submit',async event=>{
    const form=event.target;if(!form.matches('[data-vb-form]'))return;
    event.preventDefault();if(form.dataset.enabled!=='true'||state.busy)return;
    state.busy=true;const submit=form.querySelector('[type=submit]');submit.disabled=true;submit.setAttribute('aria-busy','true');
    const error=form.querySelector('[data-vb-form-error]');error.textContent='';
    try {const response=await fetch(root()+'cart/add.js',{method:'POST',body:new FormData(form)});if(!response.ok)throw new Error();openCommerceCart(submit);await fetchCart();}
    catch{error.textContent=words().error;}
    finally{state.busy=false;submit.disabled=false;submit.removeAttribute('aria-busy');}
  }, true);
  const syncMoonAccessibility = () => {
    const cart = document.querySelector('moonbundle-cart-drawer-block');
    if (!cart) return;
    const dictionary = words();
    const labels = {'.moonbundle-cart-drawer-close': dictionary.close, '.moonbundle-cart-item-remove': dictionary.remove, '[aria-label="decrease quantity"]': dictionary.decrease, '[aria-label="increase quantity"]': dictionary.increase, '.moonbundle-cart-item-quantity input': dictionary.quantity};
    Object.entries(labels).forEach(([selector, label]) => all(selector, cart).forEach(el => {
      if (label && el.getAttribute('aria-label') !== label) el.setAttribute('aria-label', label);
    }));
    all('input[placeholder]', cart).forEach(el => {
      if (el.placeholder && el.getAttribute('aria-label') !== el.placeholder) el.setAttribute('aria-label', el.placeholder);
    });
  };
  const consentOffset = () => {
    syncMoonAccessibility();
    syncMoonOfferCards();
    const privacyDialog=document.getElementById('shopify-pc__prefs__dialog');
    const privacyOpen=!!privacyDialog&&privacyDialog.getBoundingClientRect().height>0;
    if(document.body.classList.contains('vb-cookie-modal')!==privacyOpen)document.body.classList.toggle('vb-cookie-modal',privacyOpen);
    const privacyClose=document.getElementById('shopify-pc__prefs__header-close');if(privacyClose&&privacyClose.getAttribute('aria-label')!==words().close)privacyClose.setAttribute('aria-label',words().close);
    const candidates=all('#shopify-pc__banner,#shopify-privacy-banner,[data-cookie-banner],#PBarNextFrame');
    let offset=0;
    for(const el of candidates){const rect=el.getBoundingClientRect();if(rect.height>0&&rect.bottom>=innerHeight-2&&getComputedStyle(el).visibility!=='hidden')offset=Math.max(offset,el.id==='PBarNextFrame'?Math.min(rect.height,64):innerHeight-rect.top);}
    const style=document.documentElement.style;const value=offset+'px';if(style.getPropertyValue('--vb-consent-offset')!==value)style.setProperty('--vb-consent-offset',value);
    const header=document.querySelector('.vb-header');if(header){const height=header.getBoundingClientRect().height+'px';if(style.getPropertyValue('--vb-header-height')!==height)style.setProperty('--vb-header-height',height);}
  };
  let consentScheduled=false;
  const scheduleConsent=()=>{if(consentScheduled)return;consentScheduled=true;requestAnimationFrame(()=>{consentScheduled=false;consentOffset();});};
  new MutationObserver(scheduleConsent).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['style','class','hidden']});
  matchMedia('(max-width:749px)').addEventListener('change',()=>all('[data-vb-formula]').forEach(initFormula));
  window.addEventListener('resize',()=>{scheduleConsent();all('[data-vb-stories]').forEach(updateStoryDots);});
  document.addEventListener('shopify:section:load',()=>{init();scheduleConsent();});
  document.addEventListener('visitorConsentCollected',scheduleConsent);
  document.addEventListener('cart:refresh',fetchCart);
  document.addEventListener('cart:updated',fetchCart);
  window.addEventListener('moonbundle-cart-updated',fetchCart);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{init();scheduleConsent();});else{init();scheduleConsent();}
})();
  } catch(e) { console.error(e); }
})();

})();
